import {useCallback} from 'react';
import {useDispatch} from 'react-redux';

import {useCachedTable} from 'src/hooks/common-data-service/cached-table';
import {getAccountsManagers} from 'src/openapi/admin/apis/AccountManagerRelationsApi';
import {useAppDispatch} from 'src/store/hooks';

import {
    userConferencesPrimaryManagerActions,
    userConferencesPrimaryManagerDataSelector,
    userConferencesPrimaryManagerResultSelector,
} from '../slices/user-conferences-primary-manager.slice';
import {userConferencesStateSelector} from '../slices/user-conferences-state.slice';

import type {UserConferencesCacheKeys} from '../typedef';
import type {AccountPrimaryManager} from 'src/openapi/admin/models/AccountPrimaryManager';


type Props = {
    accountIds: number[],
    totalCount: number,
};

export const useGetUserConferencesPrimaryManager = ({accountIds, totalCount}: Props) => {
    const apiDispatch = useAppDispatch();
    const dispatch = useDispatch();

    const getAction = useCallback(() => apiDispatch(getAccountsManagers({
        requestBody: [...new Set(accountIds)],
    })), [accountIds, apiDispatch]);

    const setLoadedData = useCallback((
        response: Record<string, AccountPrimaryManager>,
        dataCacheKeys: UserConferencesCacheKeys,
    ) => {
        dispatch(userConferencesPrimaryManagerActions.onSuccess(({
            cacheKeys: dataCacheKeys,
            totalCount,
            data: response,
        })));
    }, [totalCount, dispatch]);

    return useCachedTable({
        dataSelector: userConferencesPrimaryManagerDataSelector,
        stateSelector: userConferencesStateSelector,
        resultSelector: userConferencesPrimaryManagerResultSelector,
        actions: userConferencesPrimaryManagerActions,
        getAction,
        onSuccessLoad: setLoadedData,
        shouldClearOnUnmount: false,
    });
};
